import api from "./api";

export const depositService = {
  // Get deposit history with filtering
  getDepositHistory: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append("status", filters.status);
    if (filters.wallet_type) params.append("wallet_type", filters.wallet_type);
    if (filters.date_from) params.append("date_from", filters.date_from);
    if (filters.date_to) params.append("date_to", filters.date_to);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.offset) params.append("offset", filters.offset);

    const queryString = params.toString();
    const url = queryString ? `/deposits?${queryString}` : "/deposits";
    const response = await api.get(url);
    return response.data;
  },

  // Get specific deposit by reference
  getDepositById: async (depositRef) => {
    const params = new URLSearchParams();
    params.append("deposit_ref", depositRef);
    const response = await api.get(`/deposits/${depositRef}`);
    return response.data;
  },

  // Helper methods for specific deposit statuses
  getPendingDeposits: async (filters = {}) => {
    return depositService.getDepositHistory({
      ...filters,
      status: "pending",
    });
  },

  getCompletedDeposits: async (filters = {}) => {
    return depositService.getDepositHistory({
      ...filters,
      status: "completed",
    });
  },

  getFailedDeposits: async (filters = {}) => {
    return depositService.getDepositHistory({
      ...filters,
      status: "failed",
    });
  },

  // Get deposits by wallet type
  getAffordableDataDeposits: async (filters = {}) => {
    return depositService.getDepositHistory({
      ...filters,
      wallet_type: "affordable_data",
    });
  },

  getAirtimeDataDeposits: async (filters = {}) => {
    return depositService.getDepositHistory({
      ...filters,
      wallet_type: "airtime_data",
    });
  },
};
